require('./bootstrap');
require('bootstrap');
require('popper.js');
require('@fortawesome/fontawesome-free/js/all.min');
